<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import TelegramReadyGuard from '@/components/TelegramReadyGuard.vue'
import StandardLayout from '@/layouts/StandardLayout.vue'
import PixelTabBar from '@/components/PixelTabBar.vue'

const route = useRoute()
const isStandard = computed(() => route.meta?.layout === 'standard')
</script>

<template>
  <TelegramReadyGuard>
    <RouterView v-if="!isStandard" />
    <StandardLayout v-else :content-padding="true">
      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component" />
        </KeepAlive>
      </RouterView>
      <template #footer>
        <PixelTabBar />
      </template>
    </StandardLayout>
  </TelegramReadyGuard>
</template>

<style scoped>
</style>
